import actions from './actions';
import mutations from './mutations';
import getters from './getters';

const state = () => ({
  projects: [],
  pageSize: 16,
  currentPage: 		0,
  sdgIdentifier: 			null,
  sdgNumProjects: 	0,
  sdgCommunity: 	0,
  sdgRaised: 		0,
  nextPage: 		null,
  prevPage: 		null,
  count: 		null
});

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
